import React from 'react';
import { Button } from '@tcc/crate';
import propTypes from 'prop-types';

import { sendVerificationEmailRequest } from 'requesters/verificationRequester';
import { getMessage } from 'i18n/i18nWrapper';
import { request } from 'constants/statuses';

import styles from './css/SendEmail.css';

const SendEmail = ({email}) => {
  const [status, setStatus] = React.useState(request.INIT);

  function sendEmail() {
    setStatus(request.PENDING);

    sendVerificationEmailRequest(email).
      then(() => setStatus(request.RESOLVED)).
      catch(() => setStatus(request.REJECTED));
  }

  return (
    <div className={styles.action}>
      <Button
        data-test-id="send-email-button"
        isLoading={status === request.PENDING}
        mode="primary"
        onClick={sendEmail}
      >
        {getMessage('sendEmail.resendEmail')}
      </Button>
      {status === request.RESOLVED && (
        <div className={styles.resolvedMessage} data-test-id="send-email-success">
          {getMessage('sendEmail.emailSent')}
        </div>
      )}
      {status === request.REJECTED && (
        <div className={styles.rejectedMessage} data-test-id="send-email-failed">
          {getMessage('sendEmail.emailFailed')}
        </div>
      )}
    </div>
  );
};

SendEmail.propTypes = {
  email: propTypes.string.isRequired
};

export default SendEmail;
